const ITEMS = ["Water-Efficient Process", "Doorstep Service", "Standardized SOPs", "Technology Enabled", "Trained Partners"];

export default function TrustMarquee() {
  return (
    <div className="border-y border-black/[0.06] bg-white py-5" data-testid="trust-marquee" aria-label="Why CARZA">
      <div className="relative overflow-hidden" style={{ maskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)", WebkitMaskImage: "linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent)" }}>
        <div className="marquee-track">
          {[0, 1].map((copy) => (
            <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
              {ITEMS.map((item) => (
                <span key={`${copy}-${item}`} className="flex items-center">
                  <span className="whitespace-nowrap px-8 font-mono text-[11px] uppercase tracking-[0.3em] text-[#3d3455] sm:text-xs">{item}</span>
                  <span className="h-1.5 w-1.5 rotate-45 bg-carza" aria-hidden="true" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
